import { Rating } from 'src/components/elements/Rating';

import { Copy } from '@/components/elements';

import {
  StyledBlockquote,
  StyledDescription,
  StyledHeader,
  StyledImage,
  StyledLinkShowMore,
  StyledLocation,
  StyledName,
  StyledPlaceholder,
  StyledRateWrapper,
  StyledTestimonialWrapper,
} from './Testimonial.styled';

type Thumbnail = {
  src: string;
  alt: string;
};

interface ThumbnailProps {
  image?: Thumbnail;
  name: string;
  index: number;
}

const Thumbnail = ({ image, name, index }: ThumbnailProps) => {
  if (image?.src) {
    return (
      <StyledImage
        src={image.src}
        alt={image.alt}
        width={32}
        height={32}
        layout="fixed"
      />
    );
  }

  return (
    <StyledPlaceholder
      text={name && name[0]}
      size="m"
      forwardedAs="span"
      $index={index}
    />
  );
};

export interface ITestimonialProps {
  name: string;
  location: string;
  rating: number;
  description: string;
  image?: Thumbnail;
  showOriginalLabel?: string;
  showOriginalLink?: string;
  index: number;
}

export const Testimonial = ({
  image,
  name,
  location,
  rating,
  description,
  showOriginalLabel,
  showOriginalLink,
  index,
}: ITestimonialProps) => {
  return (
    <StyledTestimonialWrapper>
      <StyledHeader>
        <Thumbnail image={image} name={name} index={index} />
        <cite>
          <StyledName text={name} size="m" forwardedAs="div" />
          <StyledLocation text={location} size="s" forwardedAs="div" />
        </cite>
      </StyledHeader>
      <StyledRateWrapper>
        <Rating rating={rating} />
        {showOriginalLabel && showOriginalLink && (
          <StyledLinkShowMore
            rel="noopener nofollow noreferrer"
            target="_blank"
            href={showOriginalLink}
            label={<Copy size="m" text={showOriginalLabel} />}
          />
        )}
      </StyledRateWrapper>
      <StyledBlockquote>
        <StyledDescription text={description} size="m" />
      </StyledBlockquote>
    </StyledTestimonialWrapper>
  );
};
